import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { getApi } from "../../../services/api/globalApi";
import { digitsThree } from "../../../utils/price";
import ProductsReportsFilter from "./ProductsReportsFilter";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import moment from "jalali-moment";
import { productsReportsColumns } from "../../../constant/tablesColumns/tablesColums";

export default function ProductsReports() {
  const [reportsData, setReportsData] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalSoldProduct, setTotalSoldProduct] = useState(0);
  const [activeSearchButton, setActiveSearchButton] = useState(true);

  const getProductReports = async (params) => {
    const path = "admin/reports/productPurchase";
    try {
      setActiveSearchButton(false);
      const response = await getApi({ path, params: { ...params } });
      const result = response?.data?.result;
      setReportsData(result);
      checkTotalPrice(result);
      setTotalSoldProduct(calcTotalSoldProduct(result));
    } catch (error) {
      console.log(error);
    } finally {
      setActiveSearchButton(true);
    }
  };
  const calcTotalSoldProduct = (result) => {
    return result
      .filter((item) => item.total > 0)
      .reduce((sum, item) => sum + (item.total || 0), 0);
  };
  const checkTotalPrice = (result) => {
    const total = result.reduce((sum, item) => sum + (item.totalPrice || 0), 0);
    setTotalPrice(total);
  };
  useEffect(() => {
    filterDataHandler({
      from: moment().locale("en").format("YYYY-MM-DD"),
      to: moment().locale("en").format("YYYY-MM-DD"),
    });
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };

  const data = [];

  reportsData?.map((item) =>
    data.push({
      ...item,
      name: item.name,
      buyPrice: digitsThree(item?.buyPrice),
      basePrice: digitsThree(Math.floor(item?.basePrice || 0)),
      totalPrice: digitsThree((item?.buyPrice || 0) * (item?.total || 0)),
      total: digitsThree(item.total),
      productSku: item?.productSku || "-",
      id: item._id,
    })
  );

  const exportReportsData = [];

  reportsData?.map((item) =>
    exportReportsData.push({
      نام: item.name,
      "دسته بندی": item.categories?.join(","),
      "قیمت خرید": item?.buyPrice || "ندارد",
      "قیمت فروش (قیمت قدیم در بازه)": item?.basePrice || "ندارد",
      "مجموع قیمت خرید": (item?.buyPrice || 0) * (item?.total || 0) || "ندارد",
      تعداد: item.total,
      شناسه: item?.productSku || "-",
    })
  );

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"گزارش محصولات"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel jsonData={exportReportsData} />
        </div>
      </div>
      <ProductsReportsFilter
        filterDataHandler={filterDataHandler}
        activeSearchButton={activeSearchButton}
      />
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <div className="mr-4 flex flex-col sm:flex-row  ">
          <button className="text-white h-10 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm   sm:w-auto px-8 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            {totalPrice.toLocaleString()} تومان
          </button>
        </div>

        <div className="mr-4 flex flex-col sm:flex-row  ">
          <button className="text-white h-10 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-8 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            {totalSoldProduct}عدد محصول فرخته شده
          </button>
        </div>
        <div className="mr-4 flex flex-col sm:flex-row  ">
          <button className="text-white h-10 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-8 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
            {data?.length} مجموع تعداد کل محصولات
          </button>
        </div>
      </div>
      <Table columns={productsReportsColumns} rows={data} />
    </div>
  );
}
